
import { Result } from "appworks/model/gameplay/records/results/result";
import { Contract } from "appworks/utils/contracts/contract";
import { BaseAnimateSymbolBehaviour } from "slotworks/components/matrix/symbol/behaviours/base-animate-symbol-behaviour";
import { SymbolComponent } from "slotworks/components/matrix/symbol/symbol-component";

export class AnimateOverSymbolBehaviour extends BaseAnimateSymbolBehaviour {

    public static CONTINUOUS_HIGHLIGHT: boolean = false;

    public behaviourName: string = "AnimateOver";

    /**
     * Animate over top of a symbol
     *
     * @param symbol {SymbolComponent}
     * @param [defaultAniamtion="win"] {string}
     */
    constructor(symbol: SymbolComponent, defaultAnimation: string = "win_over") {
        super(symbol, defaultAnimation);
    }

    public highlight(): Contract<void> {
        return this.animate(["_highlight_over", "_over"], ["highlight_" + this.defaultAnimation, this.defaultAnimation], false, AnimateOverSymbolBehaviour.CONTINUOUS_HIGHLIGHT);
    }

    public win(result?: Result): Contract<void> {

        return this.animate("_over", [this.defaultAnimation]);
    }

    public cycle(): Contract<void> {

        return this.animate("_over", [this.defaultAnimation]);
    }
}
